import styled, { css } from 'styled-components';

const flexCenter = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Wrapper = styled.div`
  height: calc(100vh - 220px);
  width: 100%;
  margin: 0 auto;
  max-width: 1440px;
  & .top-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
    margin-bottom: 10px;
  }
  & .right-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    & .inputs {
      width: 100%;
      display: flex;
      justify-content: end;
      align-items: center;
      gap: 15px;
      & .select__group__input {
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        margin: 0 25px 26px 0;
        &
          .ant-select-single.ant-select-lg:not(.ant-select-customize-input)
          .ant-select-selector {
          width: 100%;
          height: 44px !important;
          display: flex;
          justify-content: center;
          align-items: center;
          border: none;
          // border: 2px solid var(--custom-primary);
          padding: 0 0 20px 0;
        }
      }
    }
    & button {
      margin: 0 0 15px 15px;
      outline: none;
      border: none;
      background-color: transparent;
    }
  }
  & .reload-outlined {
    font-size: 25px;
    color: var(--custom-primary);
    cursor: pointer;
  }
  // padding: 70px;
`;

export const TaskDescription = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  gap: 10px;
  background-color: #fff;
`;

export const Actions = styled.div`
  margin: 20px 0;
  width: 100%;
  // height: 200px;
  // border: 1px solid #0093d2;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  & .primary-btn {
    padding: 10px;
  }
`;
export const LeftActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
`;

export const Tasks = styled.div`
  width: auto;
  padding: 0px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 47px;
  text-align: center;
  color: #3380ff;
`;
export const SaveBtn = styled.button`
  outline: none;
  border: none;
  width: 172px;
  height: 57px;
  padding: 5px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: #ffffff;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: 12px;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  letter-spacing: 0.07em;
  color: #3380ff;
  cursor: pointer;
  &:hover {
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.57);
  }
  &:disabled {
    cursor: not-allowed;
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
  }
`;

export const RecentWorks = styled.div`
  margin: 20px auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  & .found-works {
    display: flex;
    justify-content: start;
    gap: 20px;
    font-style: normal;
    font-weight: 300;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    color: #3d3d3d;
    & .total {
      font-weight: 500;
      font-size: 28px;
      line-height: 33px;
      color: #171717;
    }
  }
`;

export const RateComment = styled.div`
  width: 100%;
  border: 1px solid #dadada;
  padding: 10px 30px;
  border-radius: 10px;
  & ul {
    width: 100%;
    height: 160px;
    padding: 5px;
    & li {
      font-weight: 500;
      font-size: 16px;
    }
  }
`;

export const SearchBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  & .search-input {
    height: 100%;
    width: 100%;
    & input {
      padding: 7.5px !important;
    }
    & button {
      width: 60px;
      height: 54px !important;
      outline: 1px solid var(--custom-primary) !important;
      color: var(--custom-primary) !important;
    }
    & button:hover {
      background: var(--custom-primary) !important;
      color: #fff !important;
    }
    & svg {
      font-size: 26px;
    }
  }
  & .search-input .ant-input-affix-wrapper {
    border: 1px solid var(--custom-primary) !important;
  }
  & .objectName {
    width: 100%;
    height: 57px;
    border: 1px solid var(--custom-primary);
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 10px;
    padding: 10px;
    font-size: 16px;
    font-weight: bold;
    & span {
      height: 48px;
      background-color: var(--custom-primary);
      padding: 10px;
      color: #fff;
      border-radius: 4px;
    }
  }
`;
export const NoData = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  ${flexCenter}
`;

export const btnStyle = css`
  background: none;
  border: none;
  margin: 0;
  color: #c2c2c2;
`;

export const ActionButton = styled.div`
  & .edit-btn {
    ${btnStyle}
  }
  & .edit-btn:hover {
    color: var(--custom-primary);
  }
`;

export const UsersWrapper = styled.div`
  width: 100%;
  & .pagination {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 20px 0px;
  }
`;
